import React from 'react'
import { get } from 'lodash'
import { Link, Route, Switch, useRouteMatch } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import LinearProgress from '@material-ui/core/LinearProgress'
import { PageHeader } from 'components/page-header'
import Error from 'components/error'
import { MY_COACH_PROFILE } from './query'
import { Tabs, Tab } from 'components/tabs'
import CoachProfileView from './coach-profile-view'
import CoachReviewsView from './coach-reviews-view'

const CoachProfileIndexPage = () => {
  const { path, isExact } = useRouteMatch()

  const { data, loading, error } = useQuery(MY_COACH_PROFILE)

  if (loading) return <LinearProgress color="primary" />
  if (error) return <Error error={error} />

  const coachProfile = get(data, 'currentUser.attributes.coachProfile')

  const tabs = (
    <Tabs value={isExact ? 'coach profile' : 'reviews'}>
      <Tab
        label="Coach Profile"
        value="coach profile"
        component={Link}
        to={path}
      />
      <Tab
        label="Reviews"
        value="reviews"
        component={Link}
        to={`${path}/reviews`}
      />
    </Tabs>
  )
  return (
    <>
      <PageHeader title="Coach Profile" tabs={tabs} />
      <Switch>
        <Route
          exact
          path={`${path}`}
          component={() => <CoachProfileView coachProfile={coachProfile} />}
        />
        <Route
          exact
          path={`${path}/reviews`}
          component={() => <CoachReviewsView />}
        />
      </Switch>
    </>
  )
}

export default CoachProfileIndexPage
